import React from 'react';
import styles from './styles/base.module.css';
export const Label = ({
  label,
  labelTextareaTestId
}) => {
  if (!label) return null;
  return /*#__PURE__*/React.createElement("legend", {
    "data-testid": labelTextareaTestId,
    className: styles.textareaLabel
  }, /*#__PURE__*/React.createElement("span", null, label));
};